"use strict";

define('rs/form/formobjects/radio/radio.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/radio/radio.formobject.view', 'rs/form/formobjects/group/group.formobject'], function (BaseFormObject, RadioFormObjectView, GroupFormObject) {
  var RadioFormObject = BaseFormObject.extend({
    defaultValue: false,
    propertiesDefinitions: ['name', 'text'],
    linksDefinitions: ['link.displayed', 'link.required'],
    isAnswerable: true,
    isBoolean: true,
    isCommentable: function isCommentable() {
      return false;
    },
    setupView: function setupView() {
      this.setView(new RadioFormObjectView());
    },
    getRadioGroup: function getRadioGroup() {
      if (!this.getParent().getGroupId) {
        this.getParent().getGroupId = GroupFormObject.prototype.getGroupId;
      }
      return this.getParent().getGroupId();
    },
    isCompoundChild: function isCompoundChild() {
      return true;
    },
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(linker, type) {
      if (type == "required") {
        return false;
      }
      return this._super.apply(this, arguments);
    },
    requestValueChange: function requestValueChange() {
      if (!this.getFormController().getReadOnly()) {
        var value = this.getView().getValue();
        this.setValue(value, !value);
      }
    },
    getTemplateProperties: function getTemplateProperties() {
      var properties = this._super.apply(this, arguments);
      properties.id = this.getId();
      properties.radioGroup = this.getRadioGroup();
      return properties;
    },
    getCompareValue: function getCompareValue() {
      return !!this.getValue();
    }
  }, {
    getTypeString: function getTypeString() {
      return 'Radio';
    }
  });
  return RadioFormObject;
});

